(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('whitelabelService', whitelabelService);

  function whitelabelService(
    $http,
    $location,
    $q,
    ngAuthSettings,
    whitelabelManager,
  ) {
    'ngInject';

    const service = {
      getWhitelabelSettings: getWhitelabelSettings,
      validateFriendlyName: validateFriendlyName,
      saveFriendlyName: saveFriendlyName,
      saveCName: saveCName,
      deleteCName: deleteCName,
      saveWhitelabelTheme: saveWhitelabelTheme,
      publishThemeChanges: publishThemeChanges,
      checkIfSiteIsWhitelabelled: checkIfSiteIsWhitelabelled,
      checkWhitelabelSite: checkWhitelabelSite,
      getPublicWlSettings: getPublicWlSettings,
      checkLocationHostIsBase: checkLocationHostIsBase,
      getBaseFriendlyUrl: getBaseFriendlyUrl,
    };

    return service;

    function getWhitelabelSettings(accountId) {
      return $http.get(_getBaseUrl(accountId));
    }

    function validateFriendlyName(accountId, friendlyName) {
      const url = _getBaseUrl(accountId) + 'friendlyName/validate?friendlyName=' + friendlyName.toLowerCase();
      return $http.get(url);
    }

    function saveFriendlyName(accountId, friendlyName) {
      const url = _getBaseUrl(accountId) + 'friendlyName';
      return $http.patch(url, {
        friendlyName: friendlyName.toLowerCase()
      });
    }

    function saveCName(accountId, cName) {
      const url = _getBaseUrl(accountId) + 'cname';
      return $http.post(url, {
        cName: cName.toLowerCase()
      });
    }

    function deleteCName(accountId) {
      const url = _getBaseUrl(accountId) + 'cname';
      return $http.delete(url);
    }

    function saveWhitelabelTheme(accountId, theme, isLightTheme) {
      const url = _getBaseUrl(accountId) + 'theme';
      theme = angular.copy(theme);
      theme.isLightTheme = !!isLightTheme;
      return $http.patch(url, {
        theme: theme
      });
    }

    function publishThemeChanges(accountId) {
      const url = _getBaseUrl(accountId) + 'publish';
      return $http.post(url);
    }

    function checkIfSiteIsWhitelabelled(accountId) {
      const deferred = $q.defer();

      getWhitelabelSettings(accountId).then(function(response) {
        deferred.resolve(checkWhitelabelSite(response.data.whiteLabelSettings));
      }).catch(function () {
        deferred.resolve(false);
      });

      return deferred.promise;
    }

    function checkWhitelabelSite(whiteLabelSettings) {
      if (!whiteLabelSettings) {
        return false;
      }

      if (whiteLabelSettings.cnameSettings && whiteLabelSettings.cnameSettings.state === 'Deployed') {
        return whiteLabelSettings.cnameSettings.cname === $location.host() || _checkFriendlyName(whiteLabelSettings.friendlyName);
      } else if (whiteLabelSettings.friendlyName) {
        return _checkFriendlyName(whiteLabelSettings.friendlyName);
      }
      return false;
    }

    function getPublicWlSettings(options) {
      const initResult = whitelabelManager?.value?.settings;
      if (initResult) {
        return $q.resolve(initResult);
      }

      return $http.get(_getPublicWhitelabelUrl(), options);
    }

    function checkLocationHostIsBase() {
      // Delegate to whitelabelManager which already handles test mode, commonHostnames,
      // stoplist, and CNAME domains via fetchAndApplyWhitelabel().
      // If a friendlyName was detected (path-based or hostname-based), the host is not base.
      const wl = whitelabelManager.value;
      return !wl || !wl.friendlyName;
    }

    function getBaseFriendlyUrl() {
      return whitelabelManager.config.defaultHostname;
    }

    function _getFriendlyNameFromLocationUrl() {
      // Use the WL path already parsed by fetchAndApplyWhitelabel() (e.g. "nlatech").
      const wl = whitelabelManager.value;
      return (wl && wl.path) || '';
    }

    function _getLocationOrigin() {
      return _getLinkElement().origin;
    }

    function _getLinkElement() {
      const parser = document.createElement('a');
      parser.href = $location.absUrl();
      return parser;
    }

    function _checkFriendlyName(savedFriendlyName) {
      const friendlyName = _getFriendlyNameFromLocationUrl();
      return !!friendlyName && friendlyName === savedFriendlyName;
    }


    function _getPublicWhitelabelUrl() {
      return _getLocationOrigin() + (_getFriendlyNameFromLocationUrl() ? '/' + _getFriendlyNameFromLocationUrl() : '') + '/wls';
    }

    function _getBaseUrl(accountId) {
      return ngAuthSettings.apiServiceBaseUri + accountId + '/whiteLabel/';
    }

  }
})();
